export enum IPAMetricKey {
  PAGE_SESSIONS = 'PAGE_SESSIONS',
  PAGE_BR = 'PAGE_BOUNCE_RATE',
  PAGE_CTR = 'PAGE_CLICK_THROUGH_RATE',
  PAGE_AVG_TIME = 'PAGE_AVG_TIME',
  PAGE_VIEWS = 'PAGE_VIEWS',
  PAGE_RPV = 'PAGE_REVENUE_PER_VISITOR',
  PAGE_REVENUE = 'PAGE_REVENUE',
  PAGE_NEW_RETURNING_CUSTOMER = 'PAGE_NEW_RETURNING_CUSTOMER',
  PAGE_SESSIONS_BY_VISITOR = 'PAGE_SESSIONS_BY_VISITOR',
  PAGE_SESSIONS_BY_DEVICE = 'PAGE_SESSIONS_BY_DEVICE',
  PAGE_SESSIONS_BY_TRAFFIC = 'PAGE_SESSIONS_BY_TRAFFIC',
  PAGE_PATH_ANALYSIS = 'PAGE_PATH_ANALYSIS',
  PAGE_CART_ADDITION = 'PAGE_SESSION_WITH_CART_ADDITION',
  PAGE_ADDED_TO_CART = 'PAGE_ADDED_TO_CART',

  PAGE_ADD_TO_CART_RATE = 'ADD_TO_CART_RATE',
  PAGE_REACHED_CHECKOUT = 'PAGE_REACHED_CHECKOUT',
  PAGE_COMPLETE_CHECKOUT = 'PAGE_COMPLETE_CHECKOUT',
  PAGE_ORDERS = 'PAGE_ORDERS',
  PAGE_CR = 'PAGE_CONVERSION_RATE',
  PAGE_AOV = 'PAGE_AVERAGE_ORDER_VALUE',
  PAGE_VISITORS = 'PAGE_VISITORS',
}
